import React, { useState } from 'react';
import { OverlayTrigger, Popover, Button } from "react-bootstrap";
import {Tooltip} from "@material-ui/core";
import { RemoveCircleOutline } from "@material-ui/icons";

const DeleteButton = ({ onDelete, message = 'Are you sure you want to delete this game?' }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleToggle = (nextShow) => {
        setIsOpen(false);
    };

    const handleClick = () => {
        setIsOpen(prev => !prev)
    }

    return (
        <OverlayTrigger
            trigger="click"
            rootClose
            rootCloseEvent="click"
            placement='bottom'
            show={isOpen}
            onToggle={handleToggle}
            overlay={
                <Popover id="pattern-game-description">
                    <Popover.Content>
                        {message}
                        <Button
                            onClick={() => {
                                onDelete();
                                setIsOpen(false); // Close popover after deletion
                            }}
                            size="sm"
                            variant="primary"
                            className="delete-confirm-button"
                        >
                            Delete
                        </Button>
                    </Popover.Content>
                </Popover>
            }
        >
            <Tooltip title={isOpen ? "" : "Delete"} placement="top">
                <RemoveCircleOutline className="delete-example-games-button" onClick={handleClick} />
            </Tooltip>
        </OverlayTrigger>
    );
};

export default DeleteButton;
